// Constants TypeScript files should be AUTO-GENERATED by the Typewriter Visual Studio plugin. Do not modify this file.
enum ErrorPriority {
    CriticalError = 'CriticalError',
    Warning = 'Warning',
}
export default ErrorPriority;
